import { createNotImplementedMethod } from '../utils';
var NotImplementedFamilyRepository = /** @class */ (function () {
    function NotImplementedFamilyRepository() {
        this.getFamily = createNotImplementedMethod();
        this.getFamilyPlanStatus = createNotImplementedMethod();
        this.updateFamily = createNotImplementedMethod();
        this.getFamilyPreferences = createNotImplementedMethod();
        this.updateFamilyPreferences = createNotImplementedMethod();
        this.removeMember = createNotImplementedMethod();
        this.getFastMealSchedule = createNotImplementedMethod();
        this.updateFastMealSchedule = createNotImplementedMethod();
        this.getFamilyImpact = createNotImplementedMethod();
    }
    return NotImplementedFamilyRepository;
}());
export { NotImplementedFamilyRepository };
